<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div style="width:100%" v-show="organization != null">
        <v-toolbar flat color="green" class="p-1">
            <v-toolbar-title>Premises</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="addPremise()">
                Add Premise
                <v-icon right dark>create</v-icon>
            </v-btn>
        </v-toolbar>
        <v-data-table :headers="headers"
                      :items="premises"
                      class="elevation-1"
                      :pagination.sync="pagination"
                      :total-items="totalRecords">
            <template v-slot:items="props">
                <td>{{props.item.name}}</td>
                <td>{{props.item.address}}</td>
                <td>

                    <v-btn icon  v-on:click="editPremise(props.item.id)">
                        <v-icon>create</v-icon>
                    </v-btn>
                </td>
            </template>
        </v-data-table>

        <v-treeview
            :items="treeItems"
        >
            <template slot-scope="{item}" slot="label">
                <v-icon>{{item.icon}}</v-icon>
                {{item.name}}
                <v-icon v-if="item.icon == 'work'" @click="quickAddPremise(item)">create</v-icon>
            </template>
        </v-treeview>
        <AddPremise :organization-id="organization.id"></AddPremise>
    </div>
</template>

<script>
    import api from '@/api';
    import AddPremise from "../premise/AddPremise";

    export default {
        components: {AddPremise},
        inject: ['getProvidedOrganization'],
        data() {
            return {
                headers : [
                    {text:'Name',value:'name'},
                    {text:'Address',value:'address'},
                    {text:'Actions',value:''}
                ],
                premises: [],
                totalRecords: null,
                pagination: {
                    rowsPerPage: 25,
                    page: 1
                },
                filter: {
                    name: null
                },
                organization: {},
                treeItems : [],
                tree: []
            }
        },
        watch: {
            pagination: {
                handler () {
                    if (this.organization && this.organization.id) {
                        this.searchPremises();
                    }
                },
                deep: true
            }
        },
        mounted() {
            const that = this;
            this.organization = this.getProvidedOrganization();
            this.searchPremises();

            api.firstAlert.organizationConfig(this.organization.id).then((config) =>{
                that.treeItems = config;
               //console.log(config);
            });

        },
        methods : {
            editPremise (id) {
                this.$router.push({'path':"/premise/"+id});
            },
            searchPremises () {
                api.premise.search({
                    organizationId:this.organization.id,
                    pageNumber: this.pagination.page-1,
                    pageSize: this.pagination.rowsPerPage,
                    sortBy : this.pagination.sortBy,
                    sortOrder : this.pagination.descending ? 'DESC' : 'ASC'
                }).then(data => {
                    this.premises = data.list;
                    this.totalRecords = data.totalRecords;
                });
            },
            quickAddPremise(item) {
                console.log(item);
            },
            addPremise() {
                this.$router.push({name:'CreatePremise',params:{organizationId:this.organization.id}});
            }

        }
    }

</script>